import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  CateringWishesEventMeta,
  DunaCateringWishesComponent,
} from '../duna-catering-wishes/duna-catering-wishes.component';

/** Minimum event-felter til catering-ønsker dialogen. */
export interface CateringWishesDialogRow {
  event_id: number;
  guid: string;
  event_name?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  location?: string | null;
}

export interface DunaCateringPreferencesDialogData {
  row: CateringWishesDialogRow;
}

/** Shared dialog size for forplejningsønsker across all entry points. */
export const DUNA_CATERING_PREFERENCES_DIALOG_CONFIG = {
  width: '98vw',
  maxWidth: '1600px',
  maxHeight: '95vh',
};

@Component({
  selector: 'app-duna-catering-preferences-dialog',
  standalone: true,
  imports: [MatDialogModule, DunaCateringWishesComponent],
  templateUrl: './duna-catering-preferences-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './duna-catering-preferences-dialog.component.scss',
})
export class DunaCateringPreferencesDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DunaCateringPreferencesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DunaCateringPreferencesDialogData
  ) {}

  get eventMeta(): CateringWishesEventMeta {
    return {
      eventName: this.data.row.event_name || this.data.row.guid,
      guid: this.data.row.guid,
      startDate: this.data.row.start_date || null,
      endDate: this.data.row.end_date || null,
      location: this.data.row.location || null,
    };
  }

  close(): void {
    this.dialogRef.close();
  }
}
